"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageLimitEnum = void 0;
var PageLimitEnum;
(function (PageLimitEnum) {
    PageLimitEnum[PageLimitEnum["LOWEST"] = 10] = "LOWEST";
    PageLimitEnum[PageLimitEnum["LOW"] = 25] = "LOW";
    PageLimitEnum[PageLimitEnum["HIGH"] = 50] = "HIGH";
    PageLimitEnum[PageLimitEnum["HIGHEST"] = 100] = "HIGHEST";
})(PageLimitEnum = exports.PageLimitEnum || (exports.PageLimitEnum = {}));
//# sourceMappingURL=page-limit-enum.js.map